import { requestApi } from "../funcitons";

export default {
    getSettings: async () => {
        const res = await requestApi('settings/stripe/api-key', 'GET');
        return res.data;
    },
    updateStripeApiKey: async (apiKey) => {
        const res = await requestApi('settings/stripe/api-key', 'PUT', { apiKey });
        return res.data;
    },
    updateStripeWebhookSecret: async (webhookSecret) => {
        const res = await requestApi('settings/stripe/webhook-secret', 'PUT', { webhookSecret });
        return res.data;
    },
    getStripeWebhookSecret: async () => {
        const res = await requestApi('settings/stripe/webhook-secret', 'GET');
        return res.data;
    },
}